import React, { useState, useEffect } from 'react';
import './PayrollTable.css';

const API = '/api/payroll';

const CATEGORIES = [
  { value: 'fine',  label: 'Штраф',  color: '#dc2626', bg: '#fee2e2' },
  { value: 'bonus', label: 'Плюс',   color: '#059669', bg: '#d1fae5' },
  { value: 'calls', label: 'Звонки', color: '#d97706', bg: '#fef3c7' },
];

export default function Adjustments() {
  const [items, setItems]         = useState([]);
  const [employees, setEmployees] = useState([]);
  const [hotels, setHotels]       = useState([]);
  const [depts, setDepts]         = useState([]);
  const [periods, setPeriods]     = useState([]);
  const [filter, setFilter]       = useState({ hotel_id: '', period_id: '', category: '' });
  const [form, setForm]           = useState({ obj_val: '', employee_id: '', hotel_id: null, department_id: null, period_id: '', category: 'fine', amount: '', description: '', adj_date: '' });
  const [showForm, setShowForm]   = useState(false);
  const [loading, setLoading]     = useState(false);

  useEffect(() => { loadRefs(); }, []);
  useEffect(() => { loadItems(); }, [filter]);

  async function loadRefs() {
    const [h, p] = await Promise.all([
      fetch(`${API}/hotels-and-depts`).then(r => r.json()),
      fetch(`${API}/periods`).then(r => r.json()),
    ]);
    setHotels(Array.isArray(h) ? h : (h.hotels || []));
    setDepts(Array.isArray(h) ? [] : (h.departments || []));
    setPeriods(Array.isArray(p) ? p : []);
  }

  async function loadItems() {
    let url = `${API}/adjustments?`;
    if (filter.hotel_id)  url += `hotel_id=${filter.hotel_id}&`;
    if (filter.period_id) url += `period_id=${filter.period_id}`;
    let data = await fetch(url).then(r => r.json());
    if (filter.category) data = data.filter(d => d.category === filter.category);
    setItems(Array.isArray(data) ? data : []);
  }

  async function loadEmployees(val) {
    if (!val) { setEmployees([]); return; }
    const [type, id] = val.split('-');
    const url = type === 'h'
      ? `${API}/employees?hotel_id=${id}`
      : `${API}/employees?department_id=${id}`;
    const data = await fetch(url).then(r => r.json());
    setEmployees(Array.isArray(data) ? data : []);
  }

  async function save() {
    setLoading(true);
    let amount = parseFloat(form.amount);
    if (form.category === 'fine' && amount > 0) amount = -amount;
    const body = {
      employee_id: parseInt(form.employee_id),
      hotel_id: form.hotel_id,
      department_id: form.department_id,
      period_id: form.period_id ? parseInt(form.period_id) : null,
      category: form.category,
      amount,
      description: form.description,
      adj_date: form.adj_date || null,
    };
    await fetch(`${API}/adjustments`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    setShowForm(false);
    setForm({ obj_val: '', employee_id: '', hotel_id: null, department_id: null, period_id: '', category: 'fine', amount: '', description: '', adj_date: '' });
    setEmployees([]);
    loadItems(); setLoading(false);
  }

  async function remove(id) {
    if (!window.confirm('Удалить запись?')) return;
    await fetch(`${API}/adjustments/${id}`, { method: 'DELETE' });
    loadItems();
  }

  const catInfo = v => CATEGORIES.find(c => c.value === v) || CATEGORIES[0];

  const totals = items.reduce((acc, i) => {
    acc.fine  += i.category === 'fine'  ? Math.abs(parseFloat(i.amount)) : 0;
    acc.bonus += i.category === 'bonus' ? parseFloat(i.amount) : 0;
    acc.calls += i.category === 'calls' ? parseFloat(i.amount) : 0;
    return acc;
  }, { fine: 0, bonus: 0, calls: 0 });

  return (
    <div className="pt-page">
      <div className="pt-header">
        <h2>Штрафы и плюсы</h2>
        <button className="btn-primary" onClick={() => setShowForm(true)}>+ Добавить</button>
      </div>

      <div className="stat-cards">
        <div className="stat-card">
          <div className="label">Штрафы</div>
          <div className="value red">−{totals.fine.toLocaleString()} ₽</div>
        </div>
        <div className="stat-card">
          <div className="label">Плюсы</div>
          <div className="value green">+{totals.bonus.toLocaleString()} ₽</div>
        </div>
        <div className="stat-card">
          <div className="label">Звонки (итог)</div>
          <div className="value" style={{ color: totals.calls >= 0 ? '#059669' : '#dc2626' }}>
            {totals.calls >= 0 ? '+' : ''}{totals.calls.toLocaleString()} ₽
          </div>
        </div>
      </div>

      <div className="pt-filters">
        <select value={filter.hotel_id} onChange={e => setFilter(f => ({ ...f, hotel_id: e.target.value }))}>
          <option value="">Все объекты</option>
          <optgroup label="Отели">
            {hotels.map(h => <option key={h.id} value={h.id}>{h.name}</option>)}
          </optgroup>
          {depts.length > 0 && (
            <optgroup label="Подразделения">
              {depts.map(d => <option key={'d'+d.id} value={d.id}>{d.name}</option>)}
            </optgroup>
          )}
        </select>
        <select value={filter.period_id} onChange={e => setFilter(f => ({ ...f, period_id: e.target.value }))}>
          <option value="">Все периоды</option>
          {periods.map(p => (
            <option key={p.id} value={p.id}>
              {p.hotel_name} — {new Date(p.date_from).toLocaleDateString('ru')} – {new Date(p.date_to).toLocaleDateString('ru')}
            </option>
          ))}
        </select>
        <select value={filter.category} onChange={e => setFilter(f => ({ ...f, category: e.target.value }))}>
          <option value="">Все типы</option>
          {CATEGORIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
        </select>
      </div>

      <table className="pt-table">
        <thead>
          <tr><th>Сотрудник</th><th>Объект</th><th>Тип</th><th>Сумма</th><th>Описание</th><th>Дата</th><th></th></tr>
        </thead>
        <tbody>
          {items.length === 0 && (
            <tr><td colSpan={7} style={{ textAlign:'center', color:'#9ca3af', padding:40 }}>Записей нет</td></tr>
          )}
          {items.map(i => {
            const cat = catInfo(i.category);
            return (
              <tr key={i.id}>
                <td><strong>{i.full_name}</strong></td>
                <td>{i.hotel_name}</td>
                <td><span className="badge" style={{ background: cat.bg, color: cat.color }}>{cat.label}</span></td>
                <td style={{ fontWeight:600, color: parseFloat(i.amount) < 0 ? '#dc2626' : '#059669' }}>
                  {parseFloat(i.amount) > 0 ? '+' : ''}{parseFloat(i.amount).toLocaleString()} ₽
                </td>
                <td>{i.description || '—'}</td>
                <td>{i.adj_date ? new Date(i.adj_date).toLocaleDateString('ru') : '—'}</td>
                <td><button className="btn-icon danger" onClick={() => remove(i.id)}>✕</button></td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {showForm && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h3>Новая запись</h3>
              <button className="btn-icon" onClick={() => setShowForm(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <label>Тип *</label>
                <select value={form.category} onChange={e => setForm(f => ({ ...f, category: e.target.value }))}>
                  {CATEGORIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
                </select>
              </div>
              <div className="form-row">
                <label>Объект *</label>
                <select value={form.obj_val} onChange={e => {
                  const val = e.target.value;
                  const [type, id] = val ? val.split('-') : ['', ''];
                  setForm(f => ({
                    ...f,
                    obj_val: val,
                    hotel_id: type === 'h' ? parseInt(id) : null,
                    department_id: type === 'd' ? parseInt(id) : null,
                    employee_id: '',
                  }));
                  loadEmployees(val);
                }}>
                  <option value="">— выберите объект —</option>
                  <optgroup label="Отели">
                    {hotels.map(h => <option key={'h-'+h.id} value={'h-'+h.id}>{h.name}</option>)}
                  </optgroup>
                  {depts.length > 0 && (
                    <optgroup label="Подразделения">
                      {depts.map(d => <option key={'d-'+d.id} value={'d-'+d.id}>{d.name}</option>)}
                    </optgroup>
                  )}
                </select>
              </div>
              <div className="form-row">
                <label>Сотрудник *</label>
                <select value={form.employee_id} onChange={e => setForm(f => ({ ...f, employee_id: e.target.value }))} disabled={!form.obj_val}>
                  <option value="">— выберите сотрудника —</option>
                  {employees.map(e => <option key={e.id} value={e.id}>{e.full_name}</option>)}
                </select>
              </div>
              <div className="form-row">
                <label>Период</label>
                <select value={form.period_id} onChange={e => setForm(f => ({ ...f, period_id: e.target.value }))}>
                  <option value="">— без периода —</option>
                  {periods.map(p => (
                    <option key={p.id} value={p.id}>
                      {p.hotel_name} — {new Date(p.date_from).toLocaleDateString('ru')} – {new Date(p.date_to).toLocaleDateString('ru')}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-grid">
                <div className="form-row">
                  <label>Сумма (₽) *</label>
                  <input type="number" min="0" value={form.amount} onChange={e => setForm(f => ({ ...f, amount: e.target.value }))} placeholder="1000" />
                </div>
                <div className="form-row">
                  <label>Дата</label>
                  <input type="date" value={form.adj_date} onChange={e => setForm(f => ({ ...f, adj_date: e.target.value }))} />
                </div>
              </div>
              <div className="form-row">
                <label>Описание</label>
                <input value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} placeholder="За что штраф / плюс" />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-secondary" onClick={() => setShowForm(false)}>Отмена</button>
              <button className="btn-primary" onClick={save} disabled={loading || !form.employee_id || !form.amount}>
                {loading ? 'Сохраняем...' : 'Сохранить'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
